export enum B2BUserRole {
  ADMIN = 'b2badmingroup',
  CUSTOMER = 'b2bcustomergroup',
  MANAGER = 'b2bmanagergroup',
  APPROVER = 'b2bapprovergroup',
  SALESREP = 'b2bsalesrepresentant',
  WEBSUPPORT = 'b2bwebsupport',
  ACCPAYABLE = 'b2baccountpayable',
  BUYER = 'b2bbuyer',
  NOCHECKOUT = 'b2busernocheckout',
  AVAILABILITYONLY = 'b2buseravailabilityonly',
}
